<template>
    <div>
        <div v-if="hasFields">
            <div class="d-flex">
                <div class="p-2">Fields</div>

                <div class="d-flex align-items-center">
                    <a href="javascript:void(0)" @click="addField"
                       class="badge text-bg-primary mx-1">new field</a>
                </div>

            </div>


            <table class="table table-sm">
                <thead>
                <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Type</th>
                    <th scope="col"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="field in table.fields">
                    <td>
                        {{field.name}}
                    </td>

                    <td>
                        {{field.field_type}}
                    </td>

                    <td>
                        <a href="javascript:void(0)" @click="onEditClick(field)">
                            <i class="fas fa-edit"></i>
                        </a>

                        <a href="javascript:void(0)" @click="onDeleteFieldClick(field.id)">
                            <i class="fas fa-trash-alt"></i>
                        </a>
                    </td>
                </tr>

                </tbody>
            </table>

        </div>

        <div v-else class="my-4">
            <div class="alert alert-warning" role="alert">
                <p>This table does not have any fields.</p>
            </div>

            <div class="d-flex align-items-center">
                <a href="javascript:void(0)" @click="addField" class="btn btn-sm btn-danger ">new field</a>
            </div>
        </div>

        <field-modal :key="'fields-on-' + table.id" v-if="showFieldEditor" :table="table"
                     :field="currentField" @noEvent="showFieldEditor = false"></field-modal>

        <confirm-modal key="fieldModal"
                       v-if="showConfirmModal"
                       @noEvent="showConfirmModal = false"
                       :yesEvent="deleteField"
                       text="Are you sure you want to delete this field?">
        </confirm-modal>
    </div>
</template>

<script>

    import ConfirmModal from "../../components/ConfirmModal.vue"
    import FieldModal from "./FieldModal.vue";
    import ArrayUtil from "../../utils/ArrayUtil";
    import FieldService from "../../services/FieldService";

    export default {
        name: 'FieldsList',
        components: {FieldModal, ConfirmModal},
        props: ['table'],
        data() {
            return {
                model: webase.model,
                arrayUtil: new ArrayUtil(),
                currentField: {
                    name: '',
                    field_type: 'String',
                    model_id: '',
                    metadata: '',
                    required: false,
                    id: null
                },
                data: null,
                showFieldEditor: false,
                showConfirmModal: false,
                deleteField: function () {
                }
            }
        },
        computed: {
            hasFields() {
                return this.table.fields.length > 0
            }
        },
        methods: {

            addField() {
                this.currentField = {
                    name: '',
                    field_type: 'String',
                    model_id: this.table.id,
                    child_model_id: null,
                    required: false,
                    id: null
                }

                this.showFieldEditor = true
            },
            onDeleteFieldClick(fieldId) {
                let fieldService = new FieldService()
                this.showConfirmModal = true

                this.deleteField = () => {
                    fieldService.remove(fieldId).then(() => {
                        this.arrayUtil.remove(this.table.fields, fieldId)
                        this.showConfirmModal = false
                    }).catch((error) => {
                        console.log('Error removing field.')
                        console.log(error)
                        this.showConfirmModal = false
                    })
                }
            },
            onEditClick(field) {
                this.currentField = field
                this.showFieldEditor = true
            }
        }
    }
</script>
